module.exports = __webpack_public_path__ + "static/img/img-android.3f9da33.png";